import React, { useEffect, useState }  from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import SendIcon from '@mui/icons-material/Send';
import { API_URL } from '../../Constants';


function ViabilityForm() {

    let apiUrl = API_URL;

    const handleOnClickViabilityForm = () => {
        let paymentIndicator = document.getElementById("paymentIndicator").value;
        let estimatedIncome = document.getElementById("estimatedIncome").value;
        let utilizationPercentage = document.getElementById("utilizationPercentage").value;
        let bucket = document.getElementById("bucket").value;
        let creditValue = document.getElementById("creditValue").value;
        let clientUuid = localStorage.getItem('clientUuid');
        let feasibilityUuid = localStorage.getItem('feasibilityUuid');
        console.log(paymentIndicator);
        console.log(estimatedIncome);
        console.log(utilizationPercentage);
        console.log(bucket);
        console.log(creditValue);
        console.log(clientUuid);
        if (paymentIndicator === "" || estimatedIncome === "" || utilizationPercentage === "" || bucket === "" || creditValue === "") {
            alert("Revisa los campos obligatorios")
        } else {
            let study = {
                paymentIndicator: paymentIndicator,
                estimatedIncome: estimatedIncome,
                utilizationPercentage: utilizationPercentage,
                bucket: bucket,
                creditValue: creditValue,
                clientUuid: clientUuid,
                feasibilityInquiryUuid: feasibilityUuid
            }
            createViabilityStudy(study)
        }
    }

    const handlePaymentIndicatorNumber = () => {
        let paymentIndicator = document.getElementById("paymentIndicator");
        if (paymentIndicator.value < 0 || paymentIndicator.value > 950) {
            paymentIndicator.style.background = "#FA6363"
        } else {
            paymentIndicator.style.background = "white"
        }
    }


    const createViabilityStudy = (study) => {
        fetch(apiUrl + '/v1/viability-studies', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(study),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    window.location = '/general-admin';
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }
    return (
        <Container fixed>
            <br />
            <br />
            <br />
            <Box
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
            >
                <form>
                    <TextField
                        onKeyUp={handlePaymentIndicatorNumber}
                        required
                        id="paymentIndicator"
                        label="Payment Indicator"
                        type="number"
                        inputProps={{ min: 0, max: 800 }}
                        defaultValue=""
                    />
                    <br />
                    <TextField
                        required
                        id="estimatedIncome"
                        label="Estimated Income"
                        defaultValue=""

                    />
                    <br />
                    <TextField
                        required
                        id="utilizationPercentage"
                        label="Utilization Percentage"
                        defaultValue=""
                    />
                    <br />
                    <TextField
                        required
                        id="bucket"
                        label="Bucket"
                        defaultValue=""
                    />
                    <br />
                    <TextField
                        required
                        id="creditValue"
                        label="Credit Value"
                        defaultValue=""
                    />
                    <br />

                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" endIcon={<SendIcon />} onClick={handleOnClickViabilityForm}>
                            Send
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Container>

    );
}

export default ViabilityForm;